<template>
    <div class="tpl-page-container" style="padding: 0;">
        <CourseHeaderBar class="show_course_header"></CourseHeaderBar>
        <Learning></Learning>
    </div>
</template>

<script type="text/javascript">

    import Learning from '@/components/learning_page/learning.vue'
    import CourseHeaderBar from '@/components/courses_page/course/sub_components/course_header_bar.vue'

    import {mapActions, mapState} from 'vuex'

    export default {
        components: {
            Learning,
            CourseHeaderBar,
        },
        computed: {
            ...mapState({
                course_info: state => state.course.course_information,
                sign_on: state => state.loginState.sign_on,
                sub_title: '子标题'//state => state.learning.lesson_info.lesson_name
            })
        },
        methods: {
            ...mapActions({
                get_and_change_course_information: 'course/get_and_change_course_information',
                get_course_userstatus: 'course/change_course_userstatus'
            })
        },
        mounted: function () {
            let courseId = this.$route.params.id
            this.get_and_change_course_information(courseId)
            if (this.sign_on) {
                this.get_course_userstatus({'course_ids': courseId})
            }
        }

    }
</script>
<style type="text/css">
    .container {
        min-height: 540px
    }

    .show_course_header {
        height: 72px;
    }

    .course_header_bar_layout_div {
        width: 100%!important;
    }
</style>
